import React from 'react';
import { Box, Typography, Stack, Chip, Link } from '@mui/material';
import RewardBadge from '../RewardBadge';
import ImageWithFallback from '../../widgets/ImageWithFallback';
import { ReactComponent as CoinIcon } from '../../assets/icons/coin.svg';
import EditOutlinedIcon from '@mui/icons-material/EditOutlined';
import DeleteOutlinedIcon from '@mui/icons-material/DeleteOutlined';
import Inventory2OutlinedIcon from '@mui/icons-material/Inventory2Outlined';

const ProductList = ({
    products,
    onUserClick,
    shouldEdit,
    shouldDelete,
    onDeleteClick,
    onStockClick,
}) => {
    return (
        <Box
            sx={{
                borderRadius: '12px',
                marginTop: '16px',
                padding: '24px',
                overflow: 'hidden',
                backgroundColor: '#EDF8FF',
            }}
        >
            {products.map((product, index) => (
                <Box
                    key={product.id}
                    sx={{
                        display: 'flex',
                        flexDirection: 'column',
                        p: 2,
                        cursor: 'pointer',
                        borderBottom:
                            index !== products.length - 1
                                ? '1px solid #E0E0E0'
                                : 'none',
                        '&:hover': {
                            backgroundColor: '#f9f9f9',
                        },
                    }}
                    onClick={() => onUserClick(product)}
                >
                    <Box
                        sx={{
                            width: 159,
                            height: 127,
                            overflow: 'hidden',
                            borderRadius: '8px',
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                            border: '1px solid #E0E0E0',
                            backgroundColor: '#FFFFFF',
                        }}
                    >
                        <ImageWithFallback
                            src={product.photoUrl}
                            alt={product.name}
                            fallbackSrc="../../assets/images/gameup_dark.png"
                            styles={{
                                width: '100%',
                                height: '100%',
                                objectFit: 'cover',
                            }}
                        />
                    </Box>
                    <Typography
                        sx={{
                            fontFamily: 'Poppins',
                            fontSize: '14px',
                            fontWeight: '400',
                            color: '#292929',
                            mt: 2,
                        }}
                    >
                        {product.name}
                    </Typography>

                    <Typography
                        sx={{
                            fontFamily: 'Poppins',
                            fontSize: '12px',
                            fontWeight: '400',
                            color: '#666666',
                            mb: 2,
                        }}
                    >
                        {product.description}
                    </Typography>

                    <RewardBadge
                        icon={
                            <CoinIcon
                                style={{
                                    color: '#134F99',
                                    fontSize: '24px',
                                }}
                            />
                        }
                        value={product.price}
                    />

                    <Stack
                        direction="row"
                        sx={{
                            display: 'flex',
                            alignItems: 'center',
                            mt: 2,
                        }}
                    >
                        <Typography
                            sx={{
                                fontFamily: 'Poppins',
                                fontSize: '14px',
                                fontWeight: '400',
                                color: '#666666',
                            }}
                        >
                            Quantidade
                        </Typography>
                        <Typography
                            sx={{
                                fontFamily: 'Poppins',
                                fontSize: '14px',
                                fontWeight: '400',
                                color: '#292929',
                            }}
                        >
                            {product.quantity}
                        </Typography>
                    </Stack>

                    <Stack direction="column" spacing={1} sx={{ mt: 1 }}>
                        <Typography
                            sx={{
                                fontFamily: 'Poppins',
                                fontSize: '14px',
                                fontWeight: '400',
                                color: '#292929',
                            }}
                        >
                            Jogos
                        </Typography>
                        {product.games.slice(0, 3).map((game) => (
                            <Chip
                                key={game.id}
                                label={game.name}
                                size="small"
                                color="primary"
                                sx={{ maxWidth: '112px' }}
                            />
                        ))}
                    </Stack>

                    <Stack
                        direction="row"
                        spacing={2}
                        sx={{ mt: 2, justifyContent: 'start' }}
                    >
                        {shouldEdit && (
                            <Link
                                component="button"
                                onClick={(event) => {
                                    event.stopPropagation();
                                    onStockClick(product);
                                }}
                                underline="none"
                                sx={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    color: '#1F83FF',
                                }}
                            >
                                <Inventory2OutlinedIcon
                                    fontSize="small"
                                    color="#1F83FF"
                                />
                                <Typography sx={{ ml: 0.5 }}>
                                    Estoque
                                </Typography>
                            </Link>
                        )}
                        {shouldEdit && (
                            <Link
                                component="button"
                                onClick={(event) => {
                                    event.stopPropagation();
                                    onUserClick(product);
                                }}
                                underline="none"
                                sx={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    color: '#1F83FF',
                                }}
                            >
                                <EditOutlinedIcon fontSize="small" />
                                <Typography sx={{ ml: 0.5 }}>Editar</Typography>
                            </Link>
                        )}
                        {shouldDelete && (
                            <Link
                                component="button"
                                onClick={(event) => {
                                    event.stopPropagation();
                                    onDeleteClick(product);
                                }}
                                underline="none"
                                sx={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    color: 'red',
                                }}
                            >
                                <DeleteOutlinedIcon fontSize="small" />
                                <Typography sx={{ ml: 0.5 }}>
                                    Excluir
                                </Typography>
                            </Link>
                        )}
                    </Stack>
                </Box>
            ))}
        </Box>
    );
};

export default ProductList;
